import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            移动端入口
          </span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
            {appEntry.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {appEntry.description}
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {appEntry.features.map((feat) => (
              <span
                key={feat}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-700 whitespace-nowrap"
              >
                <i className="ri-check-line text-accent-500 text-sm"></i>
                {feat}
              </span>
            ))}
          </div>

          <a
            href={appEntry.ctaHref}
            className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-smartphone-line"></i>
            {appEntry.ctaText}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}